import { StateCreator } from "zustand";

type TableFilters = {
  [key: string]: { [key: string]: any };
};

// Define the state for the drawer
export interface FilterState {
  filters: TableFilters;
  setFilters: (filters: TableFilters) => void;
}

// Create a store for managing the drawer state
export const createFilterSlice: StateCreator<FilterState> = (set) => ({
  filters: {},
  setFilters(filters) {
    set({ filters });
  },
});
